import { Component, Input, OnInit } from "@angular/core";
import { NgbModal, NgbActiveModal } from "@ng-bootstrap/ng-bootstrap";
import {
  FormArray,
  FormBuilder,
  FormGroup,
  Validators,
  SelectMultipleControlValueAccessor,
} from "@angular/forms";
import { first } from "rxjs/operators";
import { NgxSpinnerService } from "ngx-spinner";
import { RequestItem } from "src/app/corporate/core/model/request-item";
import { TypeCredit } from "src/app/parametrage/core/model/type-credit";
import { Produit } from "src/app/parametrage/core/model/produit";
import { RequestItemService } from "src/app/corporate/core/service/request-item.service";
import { TypeCreditService } from "src/app/parametrage/core/service/type-credit.service";
import { ProduitService } from "src/app/parametrage/core/service/produit.service";

@Component({
  selector: "app-edit-credit-modal",
  templateUrl: "./edit-credit-modal.component.html",
  styleUrls: ["./edit-credit-modal.component.scss"],
})
export class EditCreditModalComponent implements OnInit {
  @Input() requestItemId;
  @Input() workflowCode;

  requestItem: RequestItem;

  form2: FormGroup;
  pressButton: Boolean = false;

  errorMessage: String = null;

  typeCreditLabel: string = "";

  typeCredits: TypeCredit[];
  produits: Produit[];

  constructor(
    private _requestItemService: RequestItemService,
    private _typeCreditService: TypeCreditService,
    private _produitService: ProduitService,
    private fb: FormBuilder,
    public activeModal: NgbActiveModal,
    private spinner: NgxSpinnerService
  ) {
    this.createForm();
  }

  createForm() {
    this.form2 = this.fb.group({
      typeCredit: [null, Validators.compose([Validators.required])],
      produit: [null, Validators.compose([Validators.required])],

      montant: [null, Validators.compose([Validators.required])],
      taux: [null, Validators.compose([Validators.required])],
      echeance: [null, Validators.compose([Validators.required])],
      montantAccorde: [null, Validators.compose([Validators.required])],
      tauxAccorde: [null, Validators.compose([Validators.required])],
      echeanceAccorde: [null, Validators.compose([Validators.required])],
      payeurFinal: [null, Validators.compose([Validators.nullValidator])],
      dureeTirage: [null, Validators.compose([Validators.nullValidator])],
      tauxEscompte: [null, Validators.compose([Validators.nullValidator])],
      commissionStructuration: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      commissionEngagement: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      commissionOperationCredit: [
        null,
        Validators.compose([Validators.nullValidator]),
      ],
      fraisDossier: [null, Validators.compose([Validators.nullValidator])],
      objetFinancement: [
        null,
        [
          Validators.compose([Validators.nullValidator]),
          Validators.maxLength(21843),
        ],
      ],
    });
  }

  ngOnInit() {
    this.getRequestItemById(this.requestItemId);
    this.getListTypeCredit();
  }

  getRequestItemById(requestItemId) {
    this._requestItemService.getRequestItemById(requestItemId).subscribe(
      (data) => {
        this.requestItem = data;
        this.typeCreditLabel = this.requestItem.produit.typeCredit.label;

        this.getListproduitByTypeCredit(this.requestItem.produit.typeCredit.id);

        if (this.requestItem.montantAccorde == null) {
          this.requestItem.montantAccorde = this.requestItem.montant;
        }

        if (this.requestItem.tauxAccorde == null) {
          this.requestItem.tauxAccorde = this.requestItem.taux;
        }

        if (this.requestItem.echeanceAccorde == null) {
          this.requestItem.echeanceAccorde = this.requestItem.echeance;
        }

        /*if(this.requestItem.commissionEngagementAccorde == null)
                {
                  this.requestItem.commissionEngagementAccorde = this.requestItem.commissionEngagement;
                }*/
      },
      (error) => {
        console.log(error);
      }
    );
  }

  getListTypeCredit() {
    this._typeCreditService
      .getListTypeCreditByWorkflow(this.workflowCode)
      .subscribe(
        (data) => {
          this.typeCredits = data.sort((a, b) => (a.label > b.label ? 1 : -1));
        },
        (error) => {
          console.log(error);
        }
      );
  }

  changeProduits() {
    let typeCreditId = this.form2.controls["typeCredit"].value;
    this.getListproduitByTypeCredit(typeCreditId);
  }

  getListproduitByTypeCredit(typeCreditId) {
    this._produitService.getListproduitByTypeCredit(typeCreditId).subscribe(
      (data) => {
        this.produits = data;
      },
      (error) => {
        console.log(error);
      }
    );
  }

  update(): void {
    this.spinner.show();
    this._requestItemService
      .putRequestItem(this.requestItem)
      .pipe(first())
      .subscribe(
        (data) => {
          this.spinner.hide();
          this.activeModal.close();
        },
        (error) => {
          console.log(error);
          this.spinner.hide();
        }
      );
  }
}
